/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { supportListTicketMessages } from "../../funcs/supportListTicketMessages.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListTicketMessagesRequest$inboundSchema,
};

export const tool$supportListTicketMessages: ToolDefinition<typeof args> = {
  name: "support-list-ticket-messages",
  description: `List all the messages for a support ticket.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/tickets.read\` scope.

If you're listing another account's messages, then you'll need to
specify the \`/accounts/{partnerAccountID}/tickets.read\` and \`/accounts/{accountID}/profile.read\` scopes.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await supportListTicketMessages(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
